/* eslint-disable no-case-declarations */

import {
  LOADING_ADVERTISES,
  LOADING_ADVERTISES_SUCCESS,
  LOADING_ADVERTISES_ERROR,

  ADDING_ADVERTISE,
  ADDING_ADVERTISE_SUCCESS,
  ADDING_ADVERTISE_ERROR,

  UPDATING_ADVERTISE,
  UPDATING_ADVERTISE_SUCCESS,
  UPDATING_ADVERTISE_ERROR,

  DELETING_ADVERTISE,
  DELETING_ADVERTISE_SUCCESS,
  DELETING_ADVERTISE_ERROR,

  FINDING_ADVERTISES,
  FINDING_ADVERTISES_SUCCESS,
  FINDING_ADVERTISES_ERROR,

} from '../actions/advertises';
  
  const initialState = {
    advertiseMoviePath: '',
    advertiseTotal: 0,
    advertiseList: [],
    loading: false,
    find_loading: false,
  };
  
const AdvertisesReducer = (state = initialState, action) => {
    switch (action.type) {
      case ADDING_ADVERTISE:
        return { ...state, loading: true };
  
      case ADDING_ADVERTISE_SUCCESS:
        return {
          ...state,
          loading: false,
          //advertiseList: [...state.advertiseList, action.payload],
          advertiseList: [action.payload],
          advertiseTotal: 1,
        };

      case UPDATING_ADVERTISE:
        return { ...state, loading: true };
  
      case UPDATING_ADVERTISE_SUCCESS:
        const updated_advertise = action.payload;
        const newAdvertises = state.advertiseList.map((obj) => {
          //console.log(obj);
          if (updated_advertise.id === obj.id) {
            if (updated_advertise.name) obj.name = updated_advertise.name;
            if (updated_advertise.type) obj.type = updated_advertise.type;
            if (updated_advertise.movie) obj.movie = updated_advertise.movie;
            if (updated_advertise.filesize) obj.filesize = updated_advertise.filesize;
            if (updated_advertise.image) obj.image = updated_advertise.image;
            if (updated_advertise.playtime) obj.playtime = updated_advertise.playtime;
            if (updated_advertise.agency) obj.agency = updated_advertise.agency;
            if (updated_advertise.client) obj.client = updated_advertise.client;
            if (updated_advertise.start_date) obj.start_date = updated_advertise.start_date;
            if (updated_advertise.end_date) obj.end_date = updated_advertise.end_date;
            if (updated_advertise.view_count) obj.view_count = updated_advertise.view_count;
            if (updated_advertise.cost) obj.cost = updated_advertise.cost;
            if (updated_advertise.start_time) obj.start_time = updated_advertise.start_time;
            if (updated_advertise.end_time) obj.end_time = updated_advertise.end_time;
            if (updated_advertise.area) obj.area = updated_advertise.area;
            if (updated_advertise.state) obj.state = updated_advertise.state;
            if (updated_advertise.district) obj.district = updated_advertise.district;
            if (updated_advertise.modified_user) obj.modified_user = updated_advertise.modified_user;
            if (updated_advertise.modified_at) obj.modified_at = updated_advertise.modified_at;
            //console.log(obj);
          }

          return obj;
        });
        return {
          ...state,
          loading: false,
          advertiseList: [...newAdvertises]
        };

      case DELETING_ADVERTISE:
        return { ...state, loading: true };
  
      case DELETING_ADVERTISE_SUCCESS:
        return {
          ...state,
          loading: false,
          advertiseList: [...state.advertiseList.filter((obj) => {
            const findObj = action.payload.find(removedAdvertise => (removedAdvertise.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case LOADING_ADVERTISES:
        return { ...state, loading: true };
  
      case LOADING_ADVERTISES_SUCCESS:
        const {moviePath, advertises} = action.payload;
        return {
          ...state,
          loading: false,
          advertiseMoviePath: moviePath,
          advertiseList: advertises,
        };

      // case UPDATING_TEMPLATE_CHECKS:
      //   //console.log(action.payload)
      //   return {
      //     ...state,
      //     loading: false,
      //     templateChecks: [...action.payload],
      //   };

      case FINDING_ADVERTISES:
        return { ...state, find_loading: true };

      case FINDING_ADVERTISES_SUCCESS:
        const {find_moviePath, find_total, find_advertises} = action.payload;
        return {
          ...state,
          find_loading: false,
          advertiseMoviePath: find_moviePath,
          advertiseTotal: find_total,
          advertiseList: find_advertises,
        };

      default:
        return state;
    }
  };
  
  export default AdvertisesReducer;
  